import { render } from "./BtnGerarQrCode.vue?vue&type=template&id=4f9aef72"
import script from "./BtnGerarQrCode.vue?vue&type=script&lang=js"
export * from "./BtnGerarQrCode.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__